var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3855 10.5244L3.57535 2.98044C2.74816 2.34433 2.33457 2.02628 1.98765 2.03056C1.68582 2.03429 1.40183 2.17416 1.21488 2.41115C1 2.68354 1 3.20529 1 4.24878V19.6647C1 20.7321 1 21.2658 1.21873 21.5396C1.40896 21.7777 1.69737 21.9161 2.00212 21.9154C2.35254 21.9147 2.76881 21.5806 3.60136 20.9126L13.4115 13.0406C13.9533 12.6058 14.2243 12.3884 14.3201 12.1271C14.4042 11.8981 14.4016 11.6462 14.3128 11.4189C14.2116 11.1597 13.9362 10.9479 13.3855 10.5244Z",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/PlayIcon.eedada4921a13efb0427e53b28e55553.svg";
export { ForwardRef as ReactComponent };